import { render, staticRenderFns } from "./JournalEintragListe.vue?vue&type=template&id=3af5c4e7"
import script from "./JournalEintragListe.vue?vue&type=script&lang=js"
export * from "./JournalEintragListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports